import { localizationStore } from '@stores/localization';

import { useObservable } from './useObservable';

// TODO: might be better to be defined in a single provider rather
// than alweys creating a reaction listener for subscribing to
// language changes in a hook
export const useLanguage = () =>
  useObservable(() => localizationStore.language);

/**
 * A hook for getting translations from `localizationStore`. Useful when we want to
 * get translations inside React hooks.
 *
 * Prefer using `localizationStore.getTranslation` directly in React components. This is because React components
 * wrapped in `observer` can detect Mobx store states automatically, whilst hooks can't.
 */
export const useTranslate = () =>
  useObservable(() => ({
    t: localizationStore.getTranslation,
    locale: localizationStore.language,
  }));
